import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
	selector: 'app-password-modal',
	templateUrl: './password-modal.component.html',
	styleUrls: ['./password-modal.component.scss']
})
export class PasswordModalComponent implements OnInit {
	public form: UntypedFormGroup;
	public showPassword = false;

	constructor(public dialogRef: MatDialogRef<PasswordModalComponent>,
				private _formBuilder: UntypedFormBuilder,
				private _snackbarService: SnackbarService) {
	}

	close() {
		this.dialogRef.close();
	}

	ngOnInit() {
		this.form = this._formBuilder.group({
			password: ['', Validators.required]
		})
	}

	save() {
		if (this.form.valid) {
			this.dialogRef.close(this.form.value.password);
		} else {
			this._snackbarService.openSnackBar('Please fill out all required fields.', 'Close', 3000);
		}
	}

	toggleShowPassword() {
		this.showPassword = !this.showPassword;
	}

}
